interface IProps {
  children?: React.ReactNode
  classes?: string
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  useFullHeight?: boolean
}
import classNames from 'classnames'
import { ModalContainer } from '../modal'

export const FilterModalContainer: React.FC<IProps> = ({ children, classes, onDismiss, useFullHeight }) => {
  return (
    <ModalContainer
      classes={classNames(useFullHeight && 'md:!items-start', !useFullHeight && 'md:!items-start')}
      innerClasses={classNames(
        classes,
        '!shadow-md !max-w-[350px] !min-h-0 md:!mr-[15px]',
        useFullHeight && '!h-[90lvh] sm:!h-[calc(100svh-50px)] md:!mt-[10px]',
        !useFullHeight && '!h-auto md:!mt-[10px]'
      )}
      onDismiss={onDismiss}
    >
      {children}
    </ModalContainer>
  )
}
